module.exports = __webpack_public_path__ + "img/index04.ad22c126.png";